import { ConnectDragPreview, ConnectDragSource, DragSourceMonitor, useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { ARTBOARD_CELL_ACCEPTED_DROP_TYPE } from 'components/ArtboardCell/useArtboardCellDropTarget';
import { EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';

type Props = {
  anchorBlockKey?: string;
  documentId: string;
  relationId: string;
};

type AnchorDragSourceHook = {
  isDragging: boolean;
  dragRef: ConnectDragSource;
  preview: ConnectDragPreview;
};

export const useAnchorDragSource = (props: Props): AnchorDragSourceHook => {
  const dispatch = useDispatch();
  const { anchorBlockKey, documentId, relationId } = props;
  const dragSourceType = ARTBOARD_CELL_ACCEPTED_DROP_TYPE;
  const componentType = EntityType.ANCHOR;
  const [{ isDragging }, dragRef, preview] = useDrag({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType, componentType));

      return {
        type: componentType,
        anchorBlockKey: anchorBlockKey ?? '',
        documentId,
        relationId,
      };
    },
    end: () => {
      dispatch(toggleDragState());
    },

    collect: (monitor: DragSourceMonitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return { isDragging, dragRef, preview };
};
